import { UserRoleEnum } from '@/enums/userRolesEnum';
import {HTTP} from '@/utils/httpCommonUtil';
import {Module} from 'vuex';
import {DateTime} from "luxon";

let userRoles: Array<UserRoleEnum> = [];

interface UserState {
  users: any[];
}

const state = {
  token: '',
  accessToken: '',
  appUserId: 0,
  roles: userRoles,
  tokenExpiration: 0,
  lastRoute: '',
  providerId: 0,
  isFacility: false,
  users: [],
};

const getters = {
  // If the logged in user has any of the roles passed in in the array, pass as true
  hasRole: (state: any) => (roleToVerify: Array<UserRoleEnum>) => {
    for (let i = 0; i < roleToVerify.length; i++) {
      for (let si = 0; si < state.roles.length; si++) {
        // If the user is of role MANAGER, they have unlimited access to the system.
        if (state.roles[si].id === UserRoleEnum.MANAGER || state.roles[si].id === roleToVerify[i]) {
          return true;
        }
      }
    }
    return false;
  },
  /** @deprecated Use isProvider Or isFacilityContact instead */
  hasOnlyRole: (state:any) => (roleToVerify: UserRoleEnum) => {
    return state.roles.length === 1 && state.roles[0].id === roleToVerify;
  },
  isProvider(state:any, getters: any){
    return getters.hasOnlyRole(UserRoleEnum.PROVIDER);
  },
  isFacilityContact(state:any, getters: any){
    return getters.hasOnlyRole(UserRoleEnum.FACILITY_CONTACT);
  },
  // Check to see if the token is expired
  isTokenExpired: (state: any) => () => {
    return state.tokenExpiration < new Date();
  },
  getLastRoute (state: any) {
    return state.lastRoute;
  },
  getUser: (state: UserState) => (appUserId: number) => {
    return state.users.find((user: any) => user.appUserId === appUserId);
  }
};

const actions = {
  async logoutUser (context: any) {
    try {
      if (context.state.token) {
        await HTTP.post('/api/logout');
      }
    } catch (e) {
      if (e.response && e.response.status === 401) {
        // Already logged out or our token wasn't valid anyways so no error needed
        return;
      }
      throw e;
    } finally {
      context.commit('logoutUser');
    }
  },
  async loadUsers(context: any) {
    try {
      const response = await HTTP.get('/api/users/list');
      context.commit('setUsers', response.data.data);
    } catch (err) {
      console.error('Failed to load users', err);
    }
  }
};

const mutations = {
  setUser (state: any, user: any) {
    state.appUserId = user.id;
    state.providerId = user.providerId;
    state.isFacility = user.isFacility;
    state.roles = user.roles;
  },
  logoutUser (state: any) {
    // Don't clear appUserId because that's used in the login logic.
    state.token = '';
    state.accessToken = '';
    state.roles = '';
    state.providerId = 0;
    state.isFacility = false;
  },
  setLastRoute (state: any, from: any) {
    state.lastRoute = from;
  },
  setUsers (state: any, users: any[]) {
    state.users = users;
  },
  setToken(state: any, payload: { token: string, expiresIn: number, accessToken: string }) {
    state.token = payload.token;
    state.accessToken = payload.accessToken;
    state.tokenExpiration = DateTime.local().plus({seconds: payload.expiresIn}).toJSDate().getTime();
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} as Module<UserState, any>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/store/modules/user.ts